// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","paragraph":"Loader_paragraph__Ipetv"};